import { composeIO } from 'react-compose-io'
import { RelatorioConciliacaoView } from './RelatorioConciliacao.View'
import { relatorioConciliacaoIO } from './RelatorioConciliacao.IO'

export const RelatorioConciliacao = composeIO(RelatorioConciliacaoView, relatorioConciliacaoIO)
